import { windowWidth } from "./utils";
const descMenu = {
  links: document.querySelectorAll(".jsDescMenuLink") as NodeListOf<HTMLElement>,
  subMenus: document.querySelectorAll(".jsDescSubMenu") as NodeListOf<HTMLElement>,
  header: document.getElementById("header") as HTMLElement,
  deskOverlay: document.getElementById("deskOverlay") as HTMLElement,
  headerWrap: document.getElementById('jsHeaderMain'),
  closeMenu: document.querySelectorAll(".jsCloseMenu") as NodeListOf<HTMLElement>,
  shopBtn: document.getElementById('jsOpenCats') as HTMLElement,
  shopHoverBtn: document.getElementById('jsHoverCats') as HTMLElement,
  deskNav: document.getElementById('jsDeskNav') as HTMLElement,
  brandBtn: document.getElementById('jsOpenBrands') as HTMLElement,
  brandHoverBtn: document.getElementById('jsHoverBrands') as HTMLElement,
  brandNav: document.getElementById('jsBrandsNav') as HTMLElement,
  firstLink: document.querySelector('.first-item-selected') as HTMLElement,
  init() {
    if (windowWidth  > 1200) {
      this.toggleMenu()
      this.overlayClick()
      this.setCloseAll()
      this.setShopAll()
      // this.setBrands()
      this.setCLoseMenu()
    }  
  },


  setShopAll() {

    if(this.shopBtn) {
      this.shopBtn.addEventListener('click', () => {
      this.deskNav.classList.add('activeClass');
      this.deskOverlay.classList.add("activeClass")
      this.shopBtn.classList.add('activeClass')            
      // this.brandNav.classList.remove('activeClass');
      // this.brandBtn.classList.remove('activeClass');
      this.firstLink.classList.add('activeClass');    
    
    })

  }

    if(this.shopHoverBtn) {
      this.shopHoverBtn.addEventListener('mouseenter', () => {
        this.deskNav.classList.add('activeClass');
        this.deskOverlay.classList.add("activeClass")
        this.shopHoverBtn.classList.add('activeClass')            
        // this.brandNav.classList.remove('activeClass');
        // this.brandHoverBtn.classList.remove('activeClass');
        this.firstLink.classList.add('activeClass');    
      
      })
    }



  },

//   setBrands(){

//       if(this.brandBtn) {
//         this.brandBtn.addEventListener('click', () => {
//         this.brandNav.classList.add('activeClass');
//         this.deskOverlay.classList.add("activeClass")
//         this.brandBtn.classList.add('activeClass')
//         this.deskNav.classList.remove('activeClass');
//         if(this.shopBtn) {
//          this.shopBtn.classList.remove('activeClass');
//         }
//         if(this.shopHoverBtn) {
//           this.shopHoverBtn.classList.remove('activeClass');
//          }
//     }) 
//   }

//   if(this.brandHoverBtn) {
//     this.brandHoverBtn.addEventListener('mouseenter', () => {
//     this.brandNav.classList.add('activeClass');
//     this.deskOverlay.classList.add("activeClass")
//     this.brandHoverBtn.classList.add('activeClass')
//     this.deskNav.classList.remove('activeClass');
//     if(this.shopBtn) {
//      this.shopBtn.classList.remove('activeClass');
//     }
//     if(this.shopHoverBtn) {
//       this.shopHoverBtn.classList.remove('activeClass');
//      }
// }) 
// }

  

//   },


  toggleMenu() {
    this.links.forEach((item, index) => {
      item.addEventListener("mouseenter", (e) => {
        this.resetClasses()
        e.preventDefault()
        this.header.classList.add("activeClass")
        this.deskOverlay.classList.add("activeClass")
        item.classList.add("activeClass")
        this.headerWrap?.classList.add('activeClass')
        this.subMenus[index].classList.remove("d-none");
      })
    })
  },
  resetClasses() {
    this.links.forEach((item) => item.classList.remove("activeClass"))
    this.subMenus.forEach((item) => item.classList.add("d-none"))
    this.header.classList.remove("activeClass")
    this.deskOverlay.classList.remove("activeClass")
    this.headerWrap?.classList.remove('activeClass')
  },
  setCloseAll(){
    this.closeMenu.forEach(item=>{
      item.addEventListener('click', ()=>{
        this.resetClasses()
        this.deskNav.classList.remove('activeClass');
        if(this.shopBtn) {
          this.shopBtn.classList.remove('activeClass');
        }
        if(this.shopHoverBtn) {
          this.shopHoverBtn.classList.remove('activeClass');
        }
        // this.brandNav.classList.remove('activeClass');
        // if(this.brandBtn) {
        //   this.brandBtn.classList.remove('activeClass');
        // }
        // if(this.brandHoverBtn) {
        //   this.brandHoverBtn.classList.remove('activeClass');
        // }
      })
    })
  },


  setCLoseMenu() {

    if(this.shopBtn) {
    window.addEventListener('click', (e) => {
      const target = e.target as HTMLElement; 

      if(target !== this.deskNav && !this.deskNav.contains(target) && target !== this.shopBtn && !this.shopBtn.contains(target)) {
         this.resetClasses()
        this.deskNav.classList.remove('activeClass');
        // this.brandNav.classList.remove('activeClass');
        if(this.shopBtn) {
          this.shopBtn.classList.remove('activeClass');
        }
        if(this.shopHoverBtn) {
          this.shopHoverBtn.classList.remove('activeClass');
        }
        // this.brandBtn.classList.remove('activeClass');

      }
    }) 
  }


    if(this.shopHoverBtn) {
      window.addEventListener('mouseover', e => {
      const target = e.target as HTMLElement; 

      if(target !== this.deskNav && !this.deskNav.contains(target) && target !== this.shopHoverBtn && !this.shopHoverBtn.contains(target) ) {
        this.resetClasses()
       this.deskNav.classList.remove('activeClass');
      //  this.brandNav.classList.remove('activeClass');
       if(this.shopBtn) {
         this.shopBtn.classList.remove('activeClass');
       }
       if(this.shopHoverBtn) {
         this.shopHoverBtn.classList.remove('activeClass');
       }
       
     }
    })
  }
  },

  overlayClick(){
    this.deskOverlay.addEventListener("click", (e) => {
        this.resetClasses()
    })
  }
}

export default descMenu